<section>
  <div class="ft-fin">
    <a href="https://www.intersystems.com/industries/business/financial-services/">
      Finance
    </a>

    <a href="https://www.intersystems.com/industries/healthcare-technology/">
      Health & Life Sciences
    </a>

    <a href="https://www.intersystems.com/industries/business/">
      Business
    </a>

    <a href="https://www.intersystems.com/industries/government/">
      Government
    </a>
  </div>
  <div class="ft-iris-data">
    <a href="https://www.intersystems.com/products/intersystems-iris/">
      InterSystems IRIS Data Platform
    </a>

    <a href="https://www.intersystems.com/products/intersystems-iris-for-health/">
      InterSystems IRIS for Health
    </a>

    <a href="https://www.intersystems.com/products/healthshare/">
      HealthShare
    </a>

    <a href="https://www.intersystems.com/products/trakcare/">
      TrakCare
    </a>

    <a href="https://www.intersystems.com/products/cache/">
      Caché
    </a>

    <a href="https://www.intersystems.com/products/ensemble/">
      Ensemble
    </a>
  </div>
  <div class="ft-contact">
    <a href="https://www.intersystems.com/who-we-are/contact-us/">
      Contact us
    </a>
    <a href="https://www.intersystems.com/news-events/intersystems-blogs/">
      InterSystems Blogs
    </a>
    <a href="https://www.intersystems.com/news-events/events/">
      Events
    </a>
    <a href="https://isc-partnering.ideas.aha.io/">
      Share your ideas
    </a>
    <a href="https://discord.com/channels/698987699406766170/863351145896214528" target="_blank"
       rel="noopener noreferrer">
      <img src="/img/icons/icon-discord.svg">
    </a>
  </div>
  <div class="ft-partner">
    <a href="/services">
      Find a Partner
    </a>
    <a href="/solutions">
      Find a Product
    </a>
    <a href="/technology-partners-listing">
      For technology partners
    </a>
  </div>
  <div class="ft-help">
    <a href="https://www.intersystems.com/support-learning/support/immediate-help/">
      For Immediate Help
    </a>
    <a href="https://www.intersystems.com/support-learning/learning-services/">
      Learning Services
    </a>
    <a href="https://github.com/intersystems-community/openexchange">
      Report an issue
    </a>
  </div>
</section>

<!-- Footer -->
<div class="bottom-section">
  <span>© {{ currentYear }} InterSystems Corporation. All rights reserved.</span>
  <a href="https://www.intersystems.com/privacy-policy/">Privacy & Terms</a>
  <a href="https://www.intersystems.com/guarantee/">Guarantee</a>
  <a href="https://www.intersystems.com/section-508/">Section 508</a>
  <a href="/markdown?url=/assets/doc/contest-terms.md">Contest Terms</a>
  <a href="https://community.intersystems.com/node/464261">Code of Conduct</a>
  <a href="https://community.intersystems.com/node/590421">Moderation Policy</a>
  <!--<div (click)="showOneTrustSettings()"><a>Cookies Settings</a></div>-->
</div>
